import React from 'react';
import { EnPowerLogoText, EnPowerWordmarkInline } from '../../EnPowerLogo';
import { DraggableElement } from '../../DraggableElement';
import { SOLAREA_LOGO_SRC, getSpeicherVariantCopy, isBessOffer } from './ContentPage2Speicher';

const HERO = '/speicher-hero.png';

const DATA = {
  kundenname: 'Mustermann Gewerbe GmbH',
  kundenadresse: 'Industriestraße 15, 45678 Musterstadt',
  angebotsnummer: 'SP-2025-0203',
  kundennummer: 'KD-3203',
  datum: '15. Januar 2025',
  gueltig_bis: '15. März 2025',
};

export const CoverPageSpeicher = ({
  data = {},
  editMode = false,
  showMarkers = true,
  selectedElements = [],
  elementPositions = {},
  onSelectElement,
  onPositionChange,
}) => {
  const offerData = { ...DATA, ...data };
  const variantCopy = getSpeicherVariantCopy(offerData);
  const isBess = isBessOffer(offerData);
  const honorific = String(offerData.anrede || '').trim();
  const customerName = String(offerData.kundenname || '').trim();
  const customerDisplayName = honorific && !customerName.toLowerCase().startsWith(honorific.toLowerCase())
    ? `${honorific} ${customerName}`
    : customerName;
  const dragProps = {
    editMode,
    showMarkers,
    selectedElements,
    elementPositions,
    onSelectElement,
    onPositionChange,
    dragAxis: 'y',
  };

  return (
    <div className="a4-page" data-testid="cover-page-sp" style={{ background: '#0E1E3C', overflow: 'hidden' }}>
      <DraggableElement id="SP-S1-Deckblatt" {...dragProps} initialStyle={{ width: '100%', height: '100%' }}>
    {/* Hero image */}
    <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '55%', overflow: 'hidden' }}>
      <img src={variantCopy.heroImage || HERO} alt={variantCopy.overline} style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: variantCopy.heroImage ? 'center center' : 'center 60%', display: 'block', filter: 'brightness(0.82) saturate(0.85)' }} />
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(to bottom, rgba(14,30,60,0.3) 0%, transparent 30%, rgba(14,30,60,0.6) 70%, #0E1E3C 100%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '70px', background: 'linear-gradient(to bottom, #0E1E3C 0%, transparent 100%)', pointerEvents: 'none' }} />
      <div style={{ position: 'absolute', top: 0, left: 0, width: '4px', height: '100%', background: 'linear-gradient(to bottom, #E07000, rgba(224,112,0,0.2))' }} />
    </div>

    <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '50%', background: 'linear-gradient(160deg, #122A5C 0%, #0E1E3C 100%)' }} />

    <div style={{ position: 'relative', zIndex: 10, height: '100%', display: 'flex', flexDirection: 'column', padding: '32px 48px' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
        {isBess ? (
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: '9px', height: '32px', flexShrink: 0 }}>
            <EnPowerLogoText size="lg" variant="light" />
            <span style={{ display: 'inline-flex', alignItems: 'center', height: '32px', fontFamily: 'Manrope, sans-serif', fontSize: '14px', color: 'rgba(255,255,255,0.42)', fontWeight: 700, lineHeight: 1 }}>&times;</span>
            <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '140px', height: '32px', padding: '0 6px', background: 'rgba(255,255,255,0.96)', borderRadius: '4px', boxShadow: '0 6px 18px rgba(0,0,0,0.14)', boxSizing: 'border-box', overflow: 'visible' }}>
              <img src={SOLAREA_LOGO_SRC} alt="Solarea Logo" style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} />
            </span>
          </div>
        ) : (
          <EnPowerLogoText size="lg" variant="light" />
        )}
        <div style={{ background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '4px', padding: '5px 14px', fontFamily: 'Manrope, sans-serif', fontSize: '8.5px', fontWeight: 700, color: 'rgba(255,255,255,0.8)', letterSpacing: '0.12em', textTransform: 'uppercase' }}>Indikationsangebot</div>
      </div>

      <div style={{ flex: '0 0 32%' }} />

      <div style={{ flexShrink: 0 }}>
        <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '9px', fontWeight: 700, letterSpacing: '0.16em', textTransform: 'uppercase', color: '#E07000', marginBottom: '12px' }}>{variantCopy.footer}</p>
        <h1 style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '62px', color: 'white', letterSpacing: '-0.04em', lineHeight: 0.9, marginBottom: '18px', textShadow: '0 2px 24px rgba(0,0,0,0.5)' }}>IHR<br />ANGEBOT</h1>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <div style={{ width: '52px', height: '3px', background: '#E07000', borderRadius: '2px', flexShrink: 0 }} />
          <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '13.5px', fontWeight: 500, color: 'rgba(255,255,255,0.75)', margin: 0 }}>
            Exklusiv erstellt für <span style={{ color: 'white', fontWeight: 700 }}>{customerDisplayName}</span>
          </p>
        </div>
      </div>

      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: isBess ? 'flex-start' : 'flex-end', paddingTop: isBess ? '150px' : 0, paddingBottom: isBess ? 0 : '36px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px', marginTop: '24px', padding: '8px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '7px' }}>
          <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8.5px', fontWeight: 700, color: 'rgba(255,255,255,0.72)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Projektstandort</span>
          <div style={{ width: '1px', height: '12px', background: 'rgba(255,255,255,0.15)' }} />
          <span style={{ fontFamily: 'Manrope, sans-serif', fontSize: '10.5px', fontWeight: 500, color: 'rgba(255,255,255,0.92)' }}>{offerData.kundenadresse}</span>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', borderTop: '1px solid rgba(255,255,255,0.08)', borderBottom: '1px solid rgba(255,255,255,0.08)', paddingTop: '18px', paddingBottom: '18px' }}>
          {[
            { label: 'Angebots-Nr.', value: offerData.angebotsnummer },
            { label: 'Kunden-Nr.', value: offerData.kundennummer },
            { label: 'Datum', value: offerData.datum },
            { label: 'Gültig bis', value: offerData.gueltig_bis, highlight: true },
          ].map((item, i) => (
            <div key={i} style={{ padding: '0 16px', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.08)' : 'none' }}>
              <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8px', fontWeight: 700, color: 'rgba(255,255,255,0.35)', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '5px' }}>{item.label}</p>
              <p style={{ fontFamily: 'Outfit, sans-serif', fontSize: '13px', fontWeight: 600, color: item.highlight ? '#E07000' : 'white', letterSpacing: '-0.01em', margin: 0 }}>{item.value}</p>
            </div>
          ))}
        </div>

        <p style={{ fontFamily: 'Manrope, sans-serif', fontSize: '8px', color: 'rgba(255,255,255,0.25)', letterSpacing: '0.03em', marginTop: '14px' }}>
          Dieses Angebot ist vertraulich und wurde ausschließlich für den genannten Empfänger erstellt. &middot;{' '}
          <EnPowerWordmarkInline enColor="#FFFFFF" fontSize="7px" /> &middot; info@enpower.de
        </p>
      </div>
    </div>
      </DraggableElement>
    </div>
  );
};
